(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@bingads-webui/listener"));
	else if(typeof define === 'function' && define.amd)
		define(["@bingads-webui/listener"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@bingads-webui/listener")) : factory(root["@bingads-webui/listener"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__5__) {
return 